import 'core-js/stable'
import 'regenerator-runtime/runtime'
import Vue from 'vue'
import vuetify from '@/plugins/vuetify'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@fortawesome/fontawesome-free/css/all.css'
import '@/assets/global.css'
import '@/plugins/vue-cookies'
import ApiService from '@/services/ApiService'
import '@/plugins/vue-filters'
import '@/plugins/vue-plugins'
import ErrorHandlingService from '@/services/ErrorHandlingService'
import '@/registerServiceWorker'

Vue.config.productionTip = false

ErrorHandlingService.init(store)
ApiService.init(store, router)

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
